import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { Stack, Typography } from "@mui/material";
import { BillingExplorerAllViewsHeaderActions } from "../../../header/components/BillingExplorerAllViewsHeaderActions";
import {
  PartialResourceExplorer,
  ReFolderWithChildren,
} from "@/components/pages/billing-explorer-all-views/components/table/utils/types/types";
import { hierarchyFolderNoItemsText } from "@/store/common/utils/helpers/getHierarchyAllItemsFolderChildren";
import { agGridGrandFooterColId } from "@/components/pages/common/ag-grid/utils/constants/agCommon";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerHierarchyVisibilitiesDataLoadingSelector } from "@/store/resource-explorer/selectors/views-hierarchy-visibility/resourceExplorerHierarchyVisibilitiesDataLoadingSelector";
import { BillingExplorerFolderAddReport } from "@/components/app-navigation/components/page-components/billing-explorer/components/folder-actions-menu/BillingExplorerFolderAddReport";
import { isHierarchyFolder } from "@/store/navigation/utils/helpers/isHierarchyFolder";
import { BillingExplorerFolderNameCell } from "@/components/pages/billing-explorer-all-views/components/table/components/cells/BillingExplorerFolderNameCell";
import { BillingExplorerNameCell } from "@/components/pages/billing-explorer-all-views/components/table/components/cells/BillingExplorerNameCell";

export const BillingExplorerAllItemsNameInnerRenderer: FC<
  CustomCellRendererProps<PartialResourceExplorer | ReFolderWithChildren>
> = ({ data, node }) => {
  const loading = useAppSelector(
    resourceExplorerHierarchyVisibilitiesDataLoadingSelector,
  );

  if (data?.name === hierarchyFolderNoItemsText) {
    return (
      <Stack py={2} px={1}>
        <Typography variant="body2" color="text.secondary">
          No reports inside.
        </Typography>
      </Stack>
    );
  }

  if (node.id === agGridGrandFooterColId) {
    return (
      <Stack pt={1}>
        <BillingExplorerAllViewsHeaderActions
          loading={loading}
          variant="outlined"
        />
      </Stack>
    );
  }

  if (node.footer) {
    return (
      <BillingExplorerFolderAddReport
        id={data?.id ?? ""}
        visibility={data?.visibility ?? "visible_to_everyone"}
      />
    );
  }

  if (!data) {
    return null;
  }

  const isFolder = isHierarchyFolder(data);

  if (isFolder) {
    return <BillingExplorerFolderNameCell data={data} />;
  }

  return (
    <BillingExplorerNameCell folderId={node?.parent?.data?.id} data={data} />
  );
};
